import {
  HIDE_SCORECARD_REQUIRED_MODAL,
  SHOW_SCORECARD_REQUIRED_MODAL,
} from './constants';
import { ScorecardRequiredNotice, ScorecardRequirement } from './types';

export interface ShowScorecardRequiredModalAction {
  type: typeof SHOW_SCORECARD_REQUIRED_MODAL;
  requirement: ScorecardRequirement;
  notice: ScorecardRequiredNotice | null;
}

export interface HideScorecardRequiredModalAction {
  type: typeof HIDE_SCORECARD_REQUIRED_MODAL;
}

export type ScorecardRequiredModalAction =
  | ShowScorecardRequiredModalAction
  | HideScorecardRequiredModalAction;

export function showScorecardRequiredModal(
  requirement: ScorecardRequirement,
  notice: ScorecardRequiredNotice | null = null,
): ShowScorecardRequiredModalAction {
  return {
    type: SHOW_SCORECARD_REQUIRED_MODAL,
    requirement,
    notice,
  };
}

export function hideScorecardRequiredModal(): HideScorecardRequiredModalAction {
  return {
    type: HIDE_SCORECARD_REQUIRED_MODAL,
  };
}
